<script setup>
import { localizeTeamName } from '@/__core__/localization/localization'
import EventCaption from './EventCaption.vue'
import EventCard from '@/__v1.5__/components/cards/EventCard.vue'
import { computed, inject } from 'vue'

const props = defineProps({
  events: Array
})

const status = inject('status')
const langId = inject('langId')
const widgetWidth = inject('width')

const MinuteClasses = {
  home: 'szw-mr-auto',
  away: 'szw-ml-auto'
}

function getEventProps(event) {
  if (event.cardType === 'caption') {
    return {
      title: event.title
    }
  }

  return {
    logo: event.team?.logo,
    'team-name': localizeTeamName(event.team.id, event.team.name, langId),
    title: event.title,
    subtitle: event.personName,
    minute: event.minute,
    'sprite-id': event.svgId,
    hasTeamLogo: !isTwoColumn.value
  }
}

const getEventComponent = event => (event.cardType === 'event' ? EventCard : EventCaption)

const isLoading = computed(() => status.value === 'loading')

function getMockEvents(size = 5) {
  const qualifiers = ['home', 'away']
  const mockedEvents = []

  for (let i = 0; i < size; i++) {
    mockedEvents.push({
      uuid: i,
      cardType: 'event',
      title: 'Mocked',
      personName: '',
      minute: '',
      svgId: '',
      team: {
        id: 'mock',
        name: 'Mock',
        logo: '',
        qualifier: qualifiers[Math.floor(Math.random() * qualifiers.length)]
      },
      hasTeamLogo: !isTwoColumn.value
    })
  }

  return mockedEvents
}

const adjustedEvents = computed(() => (isLoading.value ? getMockEvents(6) : props.events))
const isTwoColumn = computed(() => widgetWidth.value >= 600)
</script>

<template>
  <template v-if="isTwoColumn">
    <div class="szw-flex szw-gap-1 szw-w-full szw-items-center" v-for="event of adjustedEvents" :key="event.uuid">
      <template v-if="event.cardType === 'event'">
        <div v-if="event.team.qualifier === 'home'" style="width: calc(50% - 40px - 4px)">
          <event-card v-bind="getEventProps(event)" />
        </div>

        <div :class="['szw-flex szw-items-center szw-justify-center szw-w-[80px]', MinuteClasses[event.team.qualifier]]">
          <span v-if="isLoading" class="szw-w-[40px] szw-h-[18px] szw-bg-background-color-secondary szw-animate-pulse szw-rounded"></span>
          <span v-else>{{ event.minute }}</span>
        </div>

        <div v-if="event.team.qualifier === 'away'" style="width: calc(50% - 40px - 4px)">
          <event-card v-bind="getEventProps(event)" />
        </div>
      </template>

      <div v-else class="szw-mx-auto">
        <event-caption :title="event.title" />
      </div>
    </div>
  </template>

  <template v-else>
    <component v-for="event in adjustedEvents" :key="event.uuid" :is="getEventComponent(event)" v-bind="getEventProps(event)" />
  </template>
</template>
